<template>
  <div class="barracor">
      <p class="text-center bronze">Lucchese Computação e Estatística Ltda. &copy; 2020</p>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.barracor{
    background-color: rgb(228, 230, 114)
}
</style>